import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const SKEY = "mpower-reservation-session";
export const EXPIRY_KEY = "mpower-cart-expiry";
export const CART_KEY = "mpower-cart-v1";

export function getSessionId() {
  let s = localStorage.getItem(SKEY);
  if (!s) {
    s = (window.crypto?.randomUUID?.() || `s-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(SKEY, s);
  }
  return s;
}

export async function reserveCart(items, context) {
  const session_id = getSessionId();
  const payload = { session_id, context, items: (items || []).map((i) => ({ product_id: i.product_id, qty: i.qty })) };
  const { data } = await axios.post(`${API}/api/reservations/reserve`, payload);
  if (data.expires_at) {
    const serverExpiry = new Date(data.expires_at).getTime();
    const localExpiry = new Date(localStorage.getItem(EXPIRY_KEY) || "").getTime();
    const now = Date.now();
    // The first active expiry wins for the full cart session. Never let a
    // later reserve request extend the browser countdown; accept an earlier
    // canonical expiry from the server to repair any stale legacy session.
    const expiry = Number.isFinite(localExpiry) && localExpiry > now && Number.isFinite(serverExpiry)
      ? Math.min(localExpiry, serverExpiry)
      : serverExpiry;
    if (Number.isFinite(expiry)) localStorage.setItem(EXPIRY_KEY, new Date(expiry).toISOString());
  } else localStorage.removeItem(EXPIRY_KEY);
  window.dispatchEvent(new Event("cart-updated"));
  return data;
}

export async function releaseCart() {
  const session_id = getSessionId();
  localStorage.removeItem(EXPIRY_KEY);
  try { await axios.post(`${API}/api/reservations/release`, { session_id }); } catch { /* best-effort */ }
  window.dispatchEvent(new Event("cart-updated"));
}

export async function fetchAvailability(productIds) {
  if (!productIds || !productIds.length) return {};
  const session_id = getSessionId();
  try {
    const { data } = await axios.post(`${API}/api/reservations/availability`, { session_id, product_ids: productIds });
    return data || {};
  } catch { return {}; }
}
